import moment from 'moment';
const DEFAULT_FORMAT = 'DD MMM YYYY';

export function getFormattedDate(date, format = DEFAULT_FORMAT) {
    return moment(date).format(format);
}
